import { Breadcrumbs } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useServiceModules } from '../../../store/selectors/serviceModulesSelector';
import { ServiceModule } from '../../../types/serviceModuleTypes';
import { useLocale } from '../../../hooks/UseLocale';
import { useTranslation } from 'react-i18next';
import { BreadcrumbWrapper, CrumbLink } from '../ServiceModules.styles';

type Props = {
  folderId: number;
};

const FolderBreadcrumb = ({ folderId }: Props) => {
  const navigate = useNavigate();
  const locale = useLocale();
  const modules = useServiceModules();
   const { t } = useTranslation()

  const buildBreadcrumbs = () => {
    const crumbs: ServiceModule[] = [];
    let currentId: number | undefined = folderId;

    while (currentId) {
      const current = modules.find((m) => m.id === currentId);
      if (current) {
        crumbs.unshift(current);
        currentId = current.parentFolderServiceModuleId;
      } else {
        break;
      }
    }
    return crumbs;
  };

  const crumbs = buildBreadcrumbs();

  return (
    <BreadcrumbWrapper>
      <Breadcrumbs aria-label="breadcrumb">
      <CrumbLink
          key="root"
          onClick={() => navigate(`/${locale}/servicemodules`)}
        >
          {t("serviceModulesPage.serviceModules")}
        </CrumbLink>
        {crumbs.map((crumb, index) => (
          <CrumbLink
            key={crumb.id}
            active={index === crumbs.length - 1}
            onClick={() => navigate(`/${locale}/servicemodules/folder/${crumb.id}`)}
          >
            {crumb.name}
          </CrumbLink>
        ))}
      </Breadcrumbs>
    </BreadcrumbWrapper>
  );
};

export default FolderBreadcrumb;
